import { CSSProperties } from 'vue'

/**
 * 设置元素css
 * @param el
 * @param css
 */
export function css(el: HTMLElement, css: CSSProperties) {
  Object.keys(css).forEach((prop) => {
    el.style[prop] = css[prop]
  })
}

export function boundingRect(el: HTMLElement) {
  const rect = el.getBoundingClientRect()
  return {
    top: rect.top,
    left: rect.left,
    width: rect.width,
    height: rect.height,
  }
}

export function style(el: HTMLElement, property: string) {
  return window.getComputedStyle(el).getPropertyValue(property)
}

export function asyncScript(src: string): Promise<HTMLScriptElement> {
  return new Promise((resolve, reject) => {
    if (src.trim() === '') {
      return reject('src must not be empty!')
    }
    const scriptNode = document.createElement('script')
    scriptNode.onload = () => {
      resolve(scriptNode)
    }
    scriptNode.onerror = () => {
      reject()
    }
    scriptNode.src = src
    scriptNode.async = true
    document.head.appendChild(scriptNode)
  })
}

export function htmlEscape(str: string) {
  const escapeCharsObj = {
    '<': '&lt;',
    '>': '&gt;',
    '&': '&amp;',
    '"': '&quot;',
  }
  const re = new RegExp(`[${Object.keys(escapeCharsObj).join('')}]`, 'ig')
  return str.replace(re, (m) => escapeCharsObj[m])
}

export function escape2html(str: string) {
  const escapeCharsObj = {
    '&lt;': '<',
    '&gt;': '>',
    '&amp;': '&',
    '&quot;': '"',
  }
  const re = new RegExp(`(${Object.keys(escapeCharsObj).join('|')})`, 'ig')
  return str.replace(re, (m) => escapeCharsObj[m])
}
